export default {
    pluginName: 'bio',
    backendDataType: 'BIO',
    rowIdKey: 'DOC_ID',
    edit: 'data_edit',
    count: 'bio_count',
    totalCount: 'total_bio_count',
    fieldI18nKey: 'commonBio',
    maxPerFolder: 'max_bio_per_folder',
    maxOp: 'max_op_bio',
    staticFields: [],
    dataId: 'ID',
};
